import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { statsAPI } from "../axios/stats-axios";
import { SEMANTIC_SEARCH_FEATURE_ENABLED } from "../config/featureFlags";

const useHome = () => {
  const [loading, setLoading] = useState(false);
  const [collections, setCollections] = useState(0);
  const [pages, setPages] = useState(0);
  const [documents, setDocuments] = useState(0);
  const [focus, setFocus] = useState(false);
  const navigate = useNavigate();

  const handleBrowseManuscriptsClick = async () => {
    navigate("/browse/manuscript", {
      state: { browseResults: [] },
    });
  };

  useEffect(() => {
    localStorage.setItem("searchTerm", JSON.stringify(""));
    localStorage.setItem("searchResults", JSON.stringify([]));
    localStorage.setItem("matchType", JSON.stringify("any"));
    if (SEMANTIC_SEARCH_FEATURE_ENABLED) {
      localStorage.setItem("semanticSearchEnabled", JSON.stringify(false));
      localStorage.setItem("ragSummary", JSON.stringify(""));
    }
    localStorage.setItem("searchItemsSet", JSON.stringify(false));
    localStorage.setItem("analytics", JSON.stringify({}));
    localStorage.setItem("filters", null);
  }, []);

  useEffect(() => {
    getStats();
  }, []);


  //Below brings up the count for the pages/documents/Collections
  const getStats = async () => {
    try {
      const response = await statsAPI.get("");
      const { collections, pages, documents } = response.data;
      setCollections(collections);
      setPages(pages);
      setDocuments(documents);
    } catch (error) {
      console.log(error);
    }
  };

  return {
    loading,
    setLoading,
    collections,
    pages,
    documents,
    focus,
    setFocus,
    handleBrowseManuscriptsClick,
    getStats,
    navigate,
  };
};

export default useHome;


// we will change it to number manuscripts
